import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  styled,
  TextField,
  Tooltip,
  Typography,
  Button,
  CircularProgress,
  LinearProgress,
} from '@mui/material'
import ButtonComponent from '../../../../common/components/button/Button'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckIcon from '@mui/icons-material/Check'
import {
  checkPermission,
  executeWithTryCatch,
  gettingCompanyId,
  isNullOrEmpty,
  isResponseSuccess,
  normalizeApiResponse,
  requiredLabel,
} from '../../../../helpers/HelperFunctions'
import { useFormik } from 'formik'
import { DirectRoutingConfigFormValidation } from '../../../../validations/ServicesValidation'
import { PERMISSIONS, TOAST_MESSAGES } from '../../../../helpers/Constants'
import { useState, useMemo, useEffect } from 'react'
import { postDRConfiguration } from '../../../../api/post/postApi'
import { useToastContext } from '../../../../App'
import jwt_decode from 'jwt-decode'
import { useSearchParams } from 'react-router-dom'
import { useCommonRedux } from '../../../../store/middlewares/CommonRedux'
import GppGoodIcon from '@mui/icons-material/GppGood'
import ConfirmationModal from '../../../../common/components/custom/modal/modal'
import { setIsOrderActivatedView } from '../../../../store/slice/homeSlice'
import { useHomeRedux } from '../../Home'
import { PRODUCT_NAMES } from '../../../../helpers/Constants'
import { api_generateM365License } from '../../../../api/master/masterAPI'
import { FlexBox } from '../../../../common/styles/styled-components/StyledContainers'
import { api_AssignVoiceRoutePolicy } from '../../../../api/services/TeamsPhoneSolutionsAPI'
import { CaptionText } from '../../../../common/styles/styled-components/StyledTypography'
import {
  serviceSliceState,
  setConfiguration,
} from '../../../../store/slice/serviceSlice'
import SkeletonTableLoader from '../../../../common/components/loaders/skeletonLoader'
import { getCustomerConfiguration } from '../../../../api/get/getApi'
import { useSelector } from 'react-redux'
import EditIcon from '@mui/icons-material/Edit'
import { LOCAL_STORAGE_TEMP_CONFIG } from '../../../../helpers/constants/AuthConstants'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import {
  setIsLicenseGenerated,
  setrefreshData,
} from '../../../../store/slice/commonSlice'
import MimicProgressBar from '../../../../common/components/mimic-progress/mimic-progress'

const FlexContainer = styled(Grid)({
  display: 'flex',
  justifyContent: 'start',
  margin: '10px 0',
})
const CustomTextField = styled(TextField)({
  '& .MuiFormHelperText-root': {
    fontSize: '12px', // Adjust the font size as needed
  },
})

// --- Reusable helpers --- //
const showErrorToast = (toast, error, setBtnLoading, key) => {
  toast.showToast(normalizeApiResponse(error)?.message, 'error')
  if (setBtnLoading && key) {
    setBtnLoading((prev) => ({ ...prev, [key]: false }))
  }
}

const updateLoading = (setState, key, value) => {
  setState((prev) => ({ ...prev, [key]: value }))

}

const cleanupLocalStorage = (companyId) => {
  ['OrderActivated', 'isAlreadyActivated', 'oid', 'ct', LOCAL_STORAGE_TEMP_CONFIG.concat(companyId)].forEach(item =>
    localStorage.removeItem(item)
  )
}

const resolveCompanyId = (searchParams) => {
  const token = localStorage.getItem('sd_cp.jwt:tkn')
  if (!token) return null
  const decoded = jwt_decode(token)
  return searchParams.get('company_id') || decoded?.company_id
}


function DirectRoutingConfigDialog(props) {
  const {
    onClose,
    onChange,
    serviceName,
    goToServiceFunction,
    updateAdministrate,
  } = props
  const [btnLoading, setBtnLoading] = useState({
    saveLoading: false,
    generateLicenseLoading: false,
    submitLoading: false,
  })
  const { toast } = useToastContext()
  const serviceState = useSelector(serviceSliceState)
  const [searchParams] = useSearchParams()
  const { dispatch } = useHomeRedux()
  const OrderActivated = localStorage.getItem('OrderActivated')
  const isAlreadyActivated = localStorage.getItem('isAlreadyActivated')
  const [showPassword, setshowPassword] = useState(false)
  const { state: commonState } = useCommonRedux()
  const [showConsentAlert, setShowConsentAlert] = useState(false)
  const [showPasswordEdit, setShowPasswordEdit] = useState(
    !serviceState.configuration?.userName
  )
  const [licenseResponse, setLicenseResponse] = useState({})
  const [isSaved, setIsSaved] = useState(false)
  const [isRefreshConfig, setIsRefreshConfig] = useState(false)
  const [showEditButton, setShowEditButton] = useState(
    serviceState.configuration?.username !== null
  )

  const initialPassword = serviceState.configuration?.username ? '*******' : ''
  let intervalId = null
  const [staticPassword, setStaticPassword] = useState(initialPassword)
  const initialValues = useMemo(
    () => ({
      sbcPrefix: serviceState.configuration?.sbcPrefix?.replace("-sdc", "") || '',
      userName: serviceState.configuration?.username || '',
      password: serviceState.configuration?.username ? '' : staticPassword,
      tenantId: serviceState.configuration?.aadTenantId || '',
    }),
    [serviceState.configuration, staticPassword]
  )

  const formik = useFormik({
    initialValues,
    validationSchema: DirectRoutingConfigFormValidation,
    validateOnChange: true,
    onSubmit: () => handleConfigSubmit(),
  })
  useEffect(() => {
    if (isRefreshConfig) {
      intervalId = setInterval(() => {
        executeWithTryCatch(getConfigurationDetails, handleGetConfigError)
      }, 3000)
    }

    return () => clearInterval(intervalId)
  }, [isRefreshConfig])



  const getConfigurationDetails = async () => {
    {
      const response = await getCustomerConfiguration(resolveCompanyId(searchParams))
      if (!isResponseSuccess(response)) return
      const isAppConsented = response.data.result.isAppConsented

      if (isAppConsented) {
        dispatch(setConfiguration(response.data.result))
        setIsRefreshConfig(false)
        clearInterval(intervalId)
        toast.showToast(TOAST_MESSAGES.PermissionGranted, 'success')
      } else if (isAppConsented === false) {
        setIsRefreshConfig(false)
        clearInterval(intervalId)
        toast.showToast(TOAST_MESSAGES.PermissionDeclined, 'error')
      }
      else {
        return
      }
    }
  }



  const handleGetConfigError = (error) => {
    toast.showToast(normalizeApiResponse(error)?.message, 'error')
    setIsRefreshConfig(false)
    clearInterval(intervalId)
  }

  const getCompanyId = () => {
    const decodeToken = localStorage.getItem('sd_cp.jwt:tkn')
    const decoded = jwt_decode(decodeToken)
    if (decoded) {
      let companyId = searchParams.get('company_id')
      if (!companyId) {
        companyId = decoded?.company_id
      }
      return companyId
    }
  }
  const handleConfigSubmit = async () => {
    updateLoading(setBtnLoading, 'submitLoading', true)
    const companyId = resolveCompanyId(searchParams)
    const localConfig = localStorage.getItem(LOCAL_STORAGE_TEMP_CONFIG.concat(companyId))
    const config = isNullOrEmpty(localConfig) ? null : JSON.parse(localConfig)
    const payload = {
      companyId,
      sbcPrefix: formik.values.sbcPrefix,
      username: formik.values.userName,
      tenantId: formik.values.tenantId,
      domainEast: licenseResponse?.domainEast ?? config?.domainEast,
      domainWest: licenseResponse?.domainWest ?? config?.domainWest,
      tempUserId: licenseResponse?.tempUserId ?? config?.tempUserId,
    }

    await executeWithTryCatch(
      async () => {
        const response = await api_AssignVoiceRoutePolicy(payload, companyId)

        if (response.data.result?.automationDeploymentStatus > 0) {
          dispatch(setIsOrderActivatedView(false))
          if (!updateAdministrate) goToServiceFunction('list')
          onChange?.()
          dispatch(setConfiguration({
            ...serviceState.configuration,
            createAndAssignVoiceRoutePolicy: true,
          }))
        }

        cleanupLocalStorage(companyId)
        onClose?.()
        toast.showToast(response.data?.message || TOAST_MESSAGES.DeploymentCompleted, 'success')

        updateLoading(setBtnLoading, 'submitLoading', false)
        dispatch(setIsLicenseGenerated(false))
        dispatch(setrefreshData(true))
        goToServiceFunction('list')
        goToServiceFunction('DRlist')
      }, handleVoicePolicyAssignmentError

    )
  }

  const handleGrantPermission = () => {
    const { consentUrl } = serviceState.configuration;
    if (consentUrl) {
      setIsRefreshConfig(true)
      window.open(consentUrl, '_blank')
    } else {
      setIsRefreshConfig(false)
      setShowConsentAlert(true)
    }
  }

  const handleVoicePolicyAssignmentError = (error) => {
    updateLoading(setBtnLoading, 'submitLoading', false)
    toast.showToast(normalizeApiResponse(error)?.message, 'error')
  }

  const generateM365License = async () => {
    updateLoading(setBtnLoading, 'generateLicenseLoading', true)
    const companyId = resolveCompanyId(searchParams)

    await executeWithTryCatch(
      async () => {
        const request = { companyId, tenantId: formik.values.tenantId }
        const response = await api_generateM365License(request)

        setLicenseResponse(response.data.result)
        dispatch(setConfiguration({
          ...serviceState.configuration,
          m365License: response.data?.result?.license,
        }))

        localStorage.setItem(
          LOCAL_STORAGE_TEMP_CONFIG.concat(companyId),
          JSON.stringify(response.data.result)
        )

        dispatch(setIsLicenseGenerated(!!response.data?.result?.license))
        updateLoading(setBtnLoading, 'generateLicenseLoading', false)
      },
      handleGenerateLicenseError
    )
  }

  const handleGenerateLicenseError = (error) => {
    toast.showToast(normalizeApiResponse(error)?.message, 'error')
    dispatch(setIsLicenseGenerated(false))
    updateLoading(setBtnLoading, 'generateLicenseLoading', false)
  }

  const handleSave = async (values) => {
    updateLoading(setBtnLoading, 'saveLoading', true)
    const companyId = resolveCompanyId(searchParams)
    setShowEditButton(true)
    setshowPassword(false)
    await executeWithTryCatch(
      async () => {
        const payload = {
          ...values,
          companyId: resolveCompanyId(searchParams),
          env: process.env.REACT_APP_ENV,
        }
        setStaticPassword('*******')
        const response = await postDRConfiguration(payload)
        if (response) {
          dispatch(setIsLicenseGenerated(false))
          dispatch(setConfiguration(response?.data.result))

          const configResponse = await getCustomerConfiguration(companyId)
          if (configResponse) {
            setIsSaved(true)
            dispatch(setConfiguration({
              ...configResponse.data.result,
              userName: configResponse.data.result.username,
              aadTenantId: configResponse.data.result.aadTenantId,
            }))
            setIsRefreshConfig(true)
            window.open(configResponse.data.result?.consentUrl, '_blank')
          }
        }

        updateLoading(setBtnLoading, 'saveLoading', false)
        formik.setFieldValue('password', '*')
      },
      (err) => showErrorToast(toast, err, setBtnLoading, 'saveLoading')
    )
  }


  const handleInputChange = (e) => {
    formik.handleChange(e)
    setIsSaved(false)
    dispatch(
      setConfiguration({
        ...serviceState.configuration,
        [e.target.name]: e.target.value,
      })
    )
  }
  const handleEdit = () => {
    setShowEditButton(false)
    setStaticPassword('')
    formik.setFieldValue('password', '')
  }
  //conditions
  const isDisableSaveBtn =
    isNullOrEmpty(formik.values.password || staticPassword) ||
    isNullOrEmpty(formik.values.tenantId) ||
    isNullOrEmpty(formik.values.sbcPrefix) ||
    isNullOrEmpty(formik.values.userName)

  const isDisableSubmitBtn =
    isNullOrEmpty(formik.values.password || staticPassword) ||
    isNullOrEmpty(formik.values.tenantId) ||
    isNullOrEmpty(formik.values.sbcPrefix) ||
    isNullOrEmpty(formik.values.userName) ||
    !serviceState.configuration?.isAppConsented ||
    !commonState.isLicenseGenerated


  const getDialogTitle = (serviceName) => {
    if (!serviceName) return PRODUCT_NAMES.TPS
    return serviceName === PRODUCT_NAMES.DR ? PRODUCT_NAMES.TPS : serviceName
  }

  const FormField = ({ label, required, children }) => (
    <FlexContainer>
      <Grid item xs={12} sm={6} md={3} lg={4}>
        <Typography>{requiredLabel(label, required)}</Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={9} lg={8}>
        {children}
      </Grid>
    </FlexContainer>
  )

  const PasswordField = ({
    formik,
    showPassword,
    setShowPassword,
    showEditButton,
    staticPassword,
    handleInputChange,
    handleEdit,
    serviceState,
    isSaved,
  }) => (
    <FormField label="Password" required>
      <CustomTextField
        fullWidth
        id="password"
        name="password"
        size="small"
        autoComplete="off"
        disabled={showEditButton}
        placeholder={!showEditButton ? '' : staticPassword || '*******'}
        type={showPassword ? 'text' : 'password'}
        value={showEditButton ? '' : formik.values.password}
        onChange={handleInputChange}
        error={formik.touched.password && Boolean(formik.errors.password)}
        helperText={formik.touched.password && formik.errors.password}
        onBlur={formik.handleBlur}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {formik.values?.password?.length > 0 && serviceState.configuration?.password !== null && (
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              )}
              {(serviceState.configuration?.username && formik.values?.password?.length === 0) || isSaved ? (
                <IconButton onClick={handleEdit}
                  aria-label="edit"
                  style={{
                    float: 'end',
                    borderRadius: 0,
                    fontSize: '20px',
                  }}>
                  <EditIcon style={{
                    fontSize: '15px',
                    verticalAlign: 'end',
                    margin: '0 0px 0 0px',
                  }} />
                </IconButton>
              ) : null}
            </InputAdornment>
          ),
        }}
      />
    </FormField>
  )

  return (
    <Dialog open maxWidth="md">
      <DialogTitle id="scroll-dialog-title" display="flex" justifyContent="space-between" alignItems="center">
        <Typography fontWeight="bold" color="primary">
          Manage Account for {getDialogTitle(serviceName)}
        </Typography>
        <Tooltip title="Close">
          <IconButton edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close">
            <CancelIcon color="error" size="large" />
          </IconButton>
        </Tooltip>
      </DialogTitle>

      <form onSubmit={formik.handleSubmit}>
        <DialogContent dividers sx={{ width: '620px' }}>
          {props?.isLoading ? (
            <SkeletonTableLoader value={5} />
          ) : (
            <>
              {checkPermission(
                [
                  PERMISSIONS.masterSettingUpdate,
                  PERMISSIONS.serviceproviderSettingUpdate,
                  PERMISSIONS.resellerSettingUpdate,
                  PERMISSIONS.customerSettingUpdate,
                ],
                commonState.currentCompanyDetails
              ) && (
                  <FlexBox
                    item
                    xs={12}
                    sx={{ gap: 2, justifyContent: 'flex-end !important' }}
                  >
                    {isSaved && !serviceState.configuration?.isAppConsented && (
                      <CaptionText
                        sx={{ color: (theme) => theme.palette.error.main }}
                      >
                        Please grant the necessary permissions to generate the
                        M365 license.
                      </CaptionText>
                    )}

                    <Tooltip title="Grant Permission">
                      <IconButton
                        disable={true}
                        onClick={
                          !serviceState.configuration?.isAppConsented &&
                          handleGrantPermission
                        }
                        disableRipple={serviceState.configuration?.isAppConsented}
                        sx={{ padding: 0 }}
                      >
                        {/* Once IsAppConsented is working fine after that remove this comment and the remove code isSaved */}
                        <GppGoodIcon
                          color={
                            serviceState.configuration?.isAppConsented
                              ? 'success'
                              : 'default'
                          }
                        />
                        {/* <GppGoodIcon color={isSaved ? 'success' : 'default'} /> */}
                      </IconButton>
                    </Tooltip>
                  </FlexBox>
                )}
              {/* ✅ Domain Field */}
              <FormField label="Domain" required>
                <CustomTextField
                  fullWidth
                  id="sbcPrefix"
                  name="sbcPrefix"
                  size="small"
                  disabled
                  value={formik.values.sbcPrefix}
                  onChange={formik.handleChange}
                  error={formik.touched.sbcPrefix && Boolean(formik.errors.sbcPrefix)}
                  helperText={formik.touched.sbcPrefix && formik.errors.sbcPrefix}
                  onBlur={formik.handleBlur}
                />
              </FormField>

              {/* ✅ Admin Field */}
              <FormField label="Microsoft Admin Account" required>
                <CustomTextField
                  fullWidth
                  id="userName"
                  name="userName"
                  size="small"
                  autoComplete="off"
                  value={formik.values.userName}
                  onChange={handleInputChange}
                  error={formik.touched.userName && Boolean(formik.errors.userName)}
                  helperText={formik.touched.userName && formik.errors.userName}
                  onBlur={formik.handleBlur}
                />
              </FormField>

              {/* ✅ Password Field */}
              <PasswordField
                formik={formik}
                showPassword={showPassword}
                setShowPassword={setshowPassword}
                showEditButton={showEditButton}
                staticPassword={staticPassword}
                handleInputChange={handleInputChange}
                handleEdit={handleEdit}
                serviceState={serviceState}
                isSaved={isSaved}
              />

              {/* ✅ Tenant ID */}
              <FormField label="Tenant ID" required>
                <CustomTextField
                  fullWidth
                  id="tenantId"
                  name="tenantId"
                  size="small"
                  sx={{ flexGrow: 1 }}
                  value={formik.values.tenantId}
                  onChange={handleInputChange}
                  error={formik.touched.tenantId && Boolean(formik.errors.tenantId)}
                  helperText={formik.touched.tenantId && formik.errors.tenantId}
                  onBlur={formik.handleBlur}
                />
              </FormField>
              <FlexContainer>
                <Grid item xs={12} sm={6} md={3} lg={4}>
                  {' '}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={9}
                  lg={8}
                  sx={{ display: 'flex', gap: 2 }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: '4px',
                      minWidth: 'fit-content',
                    }}
                    disabled={isDisableSaveBtn || isSaved || !formik.dirty}
                    onClick={() => handleSave(formik.values)}
                  >
                    Authenticate{' '}
                    {btnLoading.saveLoading ? (
                      <>
                        {' '}
                        &nbsp;{' '}
                        <CircularProgress
                          size={20}
                          sx={{ color: '#fff' }}
                        />{' '}
                      </>
                    ) : null}{' '}
                  </Button>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '2px',
                    }}
                  >
                    <Button
                      text="License Pre-Requisite Check"
                      color={
                        commonState.isLicenseGenerated ||
                          serviceState.configuration?.m365License
                          ? 'success'
                          : 'primary'
                      }
                      variant="contained"
                      disabled={
                        btnLoading.generateLicenseLoading ||
                        !serviceState.configuration?.isAppConsented
                      }
                      onClick={generateM365License}
                      sx={{
                        minWidth: 'fit-content',
                        ...((commonState.isLicenseGenerated ||
                          serviceState.configuration?.m365License) && {
                          pointerEvents: 'none',
                        }),
                      }}
                    >
                      License Pre-Requisite Check
                      {(commonState.isLicenseGenerated ||
                        serviceState.configuration?.m365License) && (
                          <CheckIcon
                            sx={{
                              marginLeft: '2px',
                              fontSize: '20px',
                            }}
                          />
                        )}
                    </Button>
                    {btnLoading.generateLicenseLoading && (
                      <CircularProgress
                        size={25}
                        style={{
                          color: '#0984E3',
                          marginLeft: '5px',
                        }}
                      />
                    )}
                  </div>
                </Grid>
              </FlexContainer>
              <FlexContainer>
                <Grid item xs={12} sm={6} md={3} lg={4}>
                  {''}
                </Grid>
                <Grid item xs={12} sm={6} md={9} lg={8}>
                  {btnLoading.generateLicenseLoading ? (
                    <>
                      <MimicProgressBar />
                      <CaptionText
                        sx={{
                          color: (theme) => theme.palette.error.main,
                          marginTop: '10px',
                        }}
                      >
                        This operation may take some time. The submit button
                        will be enabled once the process is complete. 'DO NOT
                        NAVIGATE' away until this operation is completed.
                      </CaptionText>
                    </>
                  ) : null}
                  {commonState.isLicenseGenerated ? (
                    <CaptionText
                      sx={{
                        color: (theme) => theme.palette.success.main,
                        marginTop: '10px',
                      }}
                    >
                      License provisioning is complete. Click Submit to proceed
                      with deployment
                    </CaptionText>
                  ) : null}
                </Grid>
              </FlexContainer>
            </>
          )}
        </DialogContent>

        {/* ✅ Actions */}
        <DialogActions>
          <FlexContainer justifyContent="end !important" gap={1}>
            <ButtonComponent text="Cancel" color="primary" variant="outlined" onClick={onClose} />
            <Button
              color="primary"
              variant="contained"
              disabled={isDisableSubmitBtn || btnLoading.submitLoading
                ||
                serviceState.configuration?.createAndAssignVoiceRoutePolicy
              }
              onClick={() => handleConfigSubmit()}
            >
              Submit {btnLoading.submitLoading && <CircularProgress size={20} sx={{ color: '#fff' }} />}
            </Button>
          </FlexContainer>
        </DialogActions>
      </form>
      <ConfirmationModal
        title="Info"
        content={`Please set your Azure AD Tenant Id to grant admin consent!`}
        isOpen={showConsentAlert}
        hiddenConform={true}
        handleClose={() => setShowConsentAlert(false)}
      />
    </Dialog>
  )
}

export default DirectRoutingConfigDialog
